import hero from "../img/saibaba-lodhiroad.jpg";
import hero2 from "../img/SAIBABAHOME_0.png";
import aarti from "../img/Aarti_home.png";
import accomodation from "../img/Accomodation_home.png";
import darshan from "../img/Darshan_home.png";
import pooja from "../img/Pooja_home.png";
import publications from "../img/Publications_home.png";
import bimg from "../img/booking.jpg";

const data = [
  {
    hero: [
      {
        id: 1,
        title: "Shri Sai Bhakta Samaj",
        img: `${hero}`,
      },
      {
        id: 2,
        title: "Shri Sai Bhakta Samaj",
        img: `${hero2}`,
      },
      {
        id: 3,
        title: "Shri Sai Bhakta Samaj",
        img: `${hero}`,
      },
      {
        id: 4,
        title: "Shri Sai Bhakta Samaj",
        img: `${hero2}`,
      },
    ],
    about: [
      {
        id: 1,
        title: "About US",
        text: "Shri Sai Bhakta Samaj (Regd). was established in October 1968 with its Regd. Office at 27, Rajpur Road, Delhi being the residence of the then President Mr. R.S. Chitnis alongwith the following office bearers and members of Managing Committee with the noble objects to spread Baba's name/teaching amongst the public in General and devotees of Shri Sai Baba in particular, the spirit of universal brotherhood or religious toleration as embodied in Sai Bhakti, high principles of conduct and character without distinction of caste, creed and religion through mandir amongst other objects such as publishing magazines, periodicals, books etc. To promote and carry out services of all kinds which Holy SAI BABA had rendered to humanity. To establish libraries, regional centers, hospitals, Dharamshalas to help the poor and distressed to relieve human sufferings and improve standard of living and conduct. To promote unity among people belonging to different religions, caste and creed and work towards national integration with the following as office bearers and members of the 1st Managing Committee.",
        btn: "Read More",
        link: "#",
        img: "https://picsum.photos/200/300",
      },
    ],
    person: [
      {
        id: 1,
        title: "President",
        name: "Mr. R.S. Chitnis",
        img: "https://picsum.photos/200/300",
      },
      {
        id: 2,
        title: "Vice President",
        name: "Mr. N.H. Kalgavakar",
        img: "https://picsum.photos/200/300",
      },
      {
        id: 3,
        title: "Secretary",
        name: "Mr. K.B. Grover",
        img: "https://picsum.photos/200/300",
      },
      {
        id: 4,
        title: "Joint Secretary",
        name: "Mr. Siri Krishan Kapur",
        img: "https://picsum.photos/200/300",
      },
      {
        id: 5,
        title: "Treasurer",
        name: "Mr. Warman Varulkar",
        img: "https://picsum.photos/200/300",
      },
      {
        id: 6,
        title: "Joint Treasurer",
        name: "Mr. R.S. Chitnis",
        img: "https://picsum.photos/200/300",
      },
    ],
    notification: [
      {
        id: 1,
        title: "Latest News",
        text: "Devotees are hereby informed that make donations in the Donation",
        date: "20/05/2023",
        link: "#",

        img: "https://picsum.photos/200/300",
      },
      {
        id: 2,
        title: "Latest News",
        text: "Devotees are hereby informed that make donations in the Donation",
        date: "22/05/2023",
        link: "#",

        img: "https://picsum.photos/200/300",
      },
    ],
    appeal: [
      {
        id: 1,
        title: "Latest News",
        text: "Devotees are hereby informed that make donations in the Donation",
        link: "#",
        download: "#",
        img: "https://picsum.photos/200/300",
      },
      {
        id: 2,
        title: "Latest News",
        text: "Devotees are hereby informed that make donations in the Donation",
        link: "#",
        download: "#",
        img: "https://picsum.photos/200/300",
      },
    ],
    gallery: [
      {
        id: 1,
        img: `${aarti}`,
        title: "Aarti",
        link: "#",
      },
      {
        id: 2,
        img: `${darshan}`,
        title: "Darshan",
        link: "#",
      },
      {
        id: 3,
        img: `${pooja}`,
        title: "Pooja",
        link: "#",
      },
      {
        id: 4,
        img: `${accomodation}`,
        title: "Accomodation",
        link: "#",
      },
      {
        id: 5,
        img: `${publications}`,
        title: "Publications",
        link: "#",
      },
      {
        id: 6,
        img: `${aarti}`,
        title: "Aarti",
        link: "#",
      },
      {
        id: 7,
        img: `${aarti}`,
        title: "Aarti",
        link: "#",
      },
      {
        id: 8,
        img: `${darshan}`,
        title: "Darshan",
        link: "#",
      },
      {
        id: 9,
        img: `${pooja}`,
        title: "Pooja",
        link: "#",
      },
      {
        id: 10,
        img: `${accomodation}`,
        title: "Accomodation",
        link: "#",
      },
      {
        id: 11,
        img: `${publications}`,
        title: "Publications",
        link: "#",
      },
      {
        id: 12,
        img: `${aarti}`,
        title: "Aarti",
        link: "#",
      },
    ],
    d_programme: [
      {
        id: 1,
        time: "5.00 a.m.",
        title: "Temple Opens",
        link: "#",
      },
      {
        id: 2,
        time: "5.30 a.m",
        title: "Kakad Aarti",
        link: "#",
      },
      {
        id: 3,
        time: "6.00 a.m",
        title: "Mangal SNAN",
        link: "#",
      },
      {
        id: 4,
        time: "8.00 a.m",
        title: "Aarti at Morning",
        link: "#",
      },
      {
        id: 5,
        time: "12 noon",
        title: "Noon Aarti",
        link: "#",
      },
      {
        id: 6,
        time: "6.30 p.m",
        title: "Dhoop Aarti Evening Prayer",
        link: "#",
      },
      {
        id: 7,
        time: "9.30 p.m",
        title: "Shej Aarti at Night",
        link: "#",
      },
      {
        id: 8,
        time: "7.00 PM",
        title: "Thursday Dhoop Aarti Evening Prayer",
        link: "#",
      },
    ],
    l_updates: [
      {
        id: 1,
        title: "Shri Saibaba Sansthan Trust, Shirdi",
        text: "Shri Saibaba Sansthan Trust, Shirdi is pleased to launch next generation portal for availing Darshan, Aarti, Donation, Accommodation, Pooja, Membership and Publications services. Please click on the below links to avail the services.",
        btn: "Read More",
        link: "#",
        img: "https://picsum.photos/200/300",
      },

      {
        id: 2,
        title: "Shri Saibaba Sansthan Trust, Shirdi",
        text: "Shri Saibaba Sansthan Trust, Shirdi is pleased to launch next generation portal for availing Darshan, Aarti, Donation, Accommodation, Pooja, Membership and Publications services. Please click on the below links to avail the services.",
        btn: "Read More",
        link: "#",
        img: "https://picsum.photos/200/300",
      },
      {
        id: 3,
        title: "Shri Saibaba Sansthan Trust, Shirdi",
        text: "Shri Saibaba Sansthan Trust, Shirdi is pleased to launch next generation portal for availing Darshan, Aarti, Donation, Accommodation, Pooja, Membership and Publications services. Please click on the below links to avail the services.",
        btn: "Read More",
        link: "#",
        img: "https://picsum.photos/200/300",
      },
      {
        id: 4,
        title: "Shri Saibaba Sansthan Trust, Shirdi",
        text: "Shri Saibaba Sansthan Trust, Shirdi is pleased to launch next generation portal for availing Darshan, Aarti, Donation, Accommodation, Pooja, Membership and Publications services. Please click on the below links to avail the services.",
        btn: "Read More",
        link: "#",
        img: "https://picsum.photos/200/300",
      },
    ],
    booking: [
      {
        id: 1,
        title: "Accomodation",
        text: "Devotees are hereby informed that make donations in the Donation",
        link: "/booking",
        img: `${bimg}`,
        location: "#",
        youtube: "#",
        dft: "1.7 km.",
        dfbs: "2.5 km.",
        dfrs: "2.8 km.",
      },
      // {
      //   id: 2,
      //   title: "Accomodation",
      //   text: "Devotees are hereby informed that make donations in the Donation",
      //   link: "/booking",
      //   img: `${bimg}`,
      //   location: "#",
      //   youtube: "#",
      //   dft: "1.7 km.",
      //   dfbs: "2.5 km.",
      //   dfrs: "2.8 km.",
      // },
      // {
      //   id: 3,
      //   title: "Accomodation",
      //   text: "Devotees are hereby informed that make donations in the Donation",
      //   link: "/booking",
      //   img: `${bimg}`,
      //   location: "#",
      //   youtube: "#",
      //   dft: "1.7 km.",
      //   dfbs: "2.5 km.",
      //   dfrs: "2.8 km.",
      // },
    ],
    tabs: [
      {
        id: 1,
        title: "Accomodation",
        gs: [
          {
            id: 1,
            head: "",
            title:
              "Rooms Available For Booking In Shirdi On Counter Of Each Building.",
            loc: "Shri Sai Bhakta Nivash",
            sr_n: "01",
            r_type: "General",
            r_desc: "3 beds attached non AC rooms",
            min_cap: 3,
            max_cap: 5,
            rate: 200,
          },
          {
            id: 2,
            head: "",
            title:
              "Rooms Available For Booking In Shirdi On Counter Of Each Building.",
            loc: "Shri Sai Bhakta Nivash",
            sr_n: "02",
            r_type: "General",
            r_desc: "3 beds attached non AC rooms",
            min_cap: 3,
            max_cap: 5,
            rate: 200,
          },
          {
            id: 3,
            head: "",
            title:
              "Rooms Available For Booking In Shirdi On Counter Of Each Building.",
            loc: "Shri Sai Bhakta Nivash",
            sr_n: "03",
            r_type: "General",
            r_desc: "3 beds attached non AC rooms",
            min_cap: 3,
            max_cap: 5,
            rate: 200,
          },
        ],
        ac: [
          {
            id: 1,
            head: "",
            title:
              "Rooms Available For Booking In Shirdi On Counter Of Each Building.",
            loc: "Shri Sai Bhakta Nivash",
            sr_n: "01",
            r_type: "Ac",
            r_desc: "3 beds attached non AC rooms",
            min_cap: 3,
            max_cap: 5,
            rate: 200,
          },
          {
            id: 2,
            head: "",
            title:
              "Rooms Available For Booking In Shirdi On Counter Of Each Building.",
            loc: "Shri Sai Bhakta Nivash",
            sr_n: "02",
            r_type: "Ac",
            r_desc: "3 beds attached non AC rooms",
            min_cap: 3,
            max_cap: 5,
            rate: 200,
          },
          {
            id: 3,
            head: "",
            title:
              "Rooms Available For Booking In Shirdi On Counter Of Each Building.",
            loc: "Shri Sai Bhakta Nivash",
            sr_n: "03",
            r_type: "Ac",
            r_desc: "3 beds attached non AC rooms",
            min_cap: 3,
            max_cap: 5,
            rate: 200,
          },
        ],
        n_ac: [
          {
            id: 1,
            head: "",
            title:
              "Rooms Available For Booking In Shirdi On Counter Of Each Building.",
            loc: "Shri Sai Bhakta Nivash",
            sr_n: "01",
            r_type: "Non-Ac",
            r_desc: "3 beds attached non AC rooms",
            min_cap: 3,
            max_cap: 5,
            rate: 200,
          },
          {
            id: 2,
            head: "",
            title:
              "Rooms Available For Booking In Shirdi On Counter Of Each Building.",
            loc: "Shri Sai Bhakta Nivash",
            sr_n: "02",
            r_type: "Non-Ac",
            r_desc: "3 beds attached non AC rooms",
            min_cap: 3,
            max_cap: 5,
            rate: 200,
          },
          {
            id: 3,
            head: "",
            title:
              "Rooms Available For Booking In Shirdi On Counter Of Each Building.",
            loc: "Shri Sai Bhakta Nivash",
            sr_n: "03",
            r_type: "Non-Ac",
            r_desc: "3 beds attached non AC rooms",
            min_cap: 3,
            max_cap: 5,
            rate: 200,
          },
        ],
      },
    ],
  },
];

export default data;
